import { Card, Checkbox, Row, Col } from 'antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardContext } from './DashboardContext';
import useSeriesFields from './shared/useSeriesField';

const currentMonthCheckbox = 'displayCurrentMonth';
const lastMonthCheckbox = 'displayLastMonth';

const colSpan = { xxl: 4, xl: 5, lg: 6, md: 8, sm: 24, xs: 24 };

const DisplayControl = () => {
    const { t } = useTranslation(['dashboard']);
    const { currentMonth, lastMonth } = useSeriesFields();
    const [checkedValues, setCheckedValues] = useState<CheckboxValueType[]>([currentMonth, lastMonth]);

    const { setDisplayCurrentMonth, setDisplayLastMonth } = useDashboardContext();

    const onCheckboxGroupChange = useCallback(
        (checked: CheckboxValueType[]) => {
            const values = checked?.length === 0 ? [currentMonth, lastMonth] : checked;
            setDisplayCurrentMonth(values.includes(currentMonth));
            setDisplayLastMonth(values.includes(lastMonth));
            setCheckedValues(values);
        },
        [currentMonth, lastMonth, setDisplayCurrentMonth, setDisplayLastMonth, setCheckedValues]
    );

    return (
        <Card>
            <Checkbox.Group onChange={onCheckboxGroupChange} style={{ width: '100%' }} value={checkedValues}>
                <Row gutter={[8, 8]}>
                    <Col lg={2} md={4} sm={24} xs={24}>
                        {t('dashboard:displayControl.title')}
                    </Col>
                    <Col {...colSpan}>
                        <Checkbox name={currentMonthCheckbox} value={currentMonth}>
                            {currentMonth}
                        </Checkbox>
                    </Col>
                    <Col {...colSpan}>
                        <Checkbox name={lastMonthCheckbox} value={lastMonth}>
                            {lastMonth}
                        </Checkbox>
                    </Col>
                </Row>
            </Checkbox.Group>
        </Card>
    );
};

export default DisplayControl;
